import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {fetchRefreshToken} from 'features/Login/login.slice'
import _ from 'lodash'
import moment from 'moment'
import {store} from './store'

const initialState = {
    refreshTokenHitDate: '',
    message: ''
}

const DATE_FORMAT = 'YYYY-MM-DD HH:mm'

// Thunk function which acts as middleware to hold the request for RefreshToken
export const refreshTokenThunk = createAsyncThunk(
    'login/refreshTokenThunk',
    async (payload: any, {rejectWithValue}) => {
        const date = moment(_.get(store.getState(), 'refreshTokenThunkReducer.refreshTokenHitDate', new Date())).format(
            DATE_FORMAT
        )
        const present = moment(new Date()).format(DATE_FORMAT)
        if (date !== present) {
            const dispatch = store.dispatch
            await dispatch(fetchRefreshToken(payload))
            return present
        } else {
            return rejectWithValue({message: 'Token Exists'})
        }
    }
)

export const refreshTokenThunkSlice = createSlice({
    name: 'refreshTokenThunk',
    initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder.addCase(refreshTokenThunk.fulfilled, (state, action) => {
            state.refreshTokenHitDate = action.payload
            state.message = ''
        })
        builder.addCase(refreshTokenThunk.rejected, (state, action) => {
            state.message = 'Token Exists'
        })
    }
})

export const {reducer: refreshTokenThunkReducer} = refreshTokenThunkSlice

// Defining a queue to hold the thunks
const thunkQueue: Array<() => Promise<void>> = []
let isExecuting = false

// Function to execute the thunk from the queue
const executeNextThunk = async (next: any) => {
    if (thunkQueue.length > 0 && !isExecuting) {
        isExecuting = true
        const nextAction = thunkQueue.shift()
        if (nextAction) {
            next(nextAction) // Continue with next thunk in the queue
        }
    }
}

// Thunk middleware to control the execution flow
const thunkMiddleware = () => (next: any) => async (action: any) => {
    if (action.type === refreshTokenThunk.pending.type) {
        thunkQueue.push(action) // Add thunk to the queue
        await executeNextThunk(next) // Try to execute the thunk
    } else if (action === refreshTokenThunk.fulfilled.type) {
        // Execute the next thunk
        isExecuting = false
        await executeNextThunk(next)
    }
    return next(action)
}

export default thunkMiddleware
